<template>
  <div class="app-shell">
    <Sidebar :collapsed="collapsed" @navigate="closeMobileMenu" />
    <div class="app-main">
      <Header :collapsed="collapsed" @toggle="collapsed = !collapsed" />
      <main class="app-content">
        <router-view />
      </main>
    </div>
    <div v-if="!collapsed" class="mobile-mask" @click="collapsed = true"></div>
  </div>
</template>

<script>
import Header from './Header.vue';
import Sidebar from './Sidebar.vue';

export default {
  name: 'Layout',
  components: { Header, Sidebar },
  data() {
    return {
      collapsed: window.innerWidth <= 768
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 768) {
        this.collapsed = true;
      }
    },
    closeMobileMenu() {
      if (window.innerWidth <= 768) {
        this.collapsed = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/Layout.vue